import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "filterArea"
}
const _hoisted_2 = { class: "lz-flex lz-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "lz-mr-1 lz-text-[1.4rem]/[1.75rem]" }, "×", -1)
const _hoisted_4 = { class: "lz-flex lz-mt-4 lz-flex-wrap" }
const _hoisted_5 = {
  key: 1,
  class: "filter-area-mobile"
}

import { ref, onMounted, onBeforeUnmount, computed, inject } from 'vue';
  import LzMultiSelectDropdown from '@/components/base/LzMultiSelectDropdown.vue';
  import LzChip from '@/components/base/LzChip.vue';
  import LzIcon from '@/components/base/LzIcon.vue';
  import LzModalFilter from '../base/LzModalFilter.vue';
  import { newsRestEndpoint } from '@/utils';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LzNewsFilter',
  emits: ['filter-applied'],
  setup(__props, { emit }) {

  

  const years = ref([]);
  const categories = ref([]);
  const selectedYears = ref([]);
  const selectedCategories = ref([]);

  const yearDropdownOpen = ref(false);
  const categoryDropdownOpen = ref(false);

  const lang = inject<string>('lang');
  const isMobile = inject<boolean>('isMobile');
  const t = inject('translations');

  const isMobileComputed = computed(() => isMobile.value);

  const yearKey = (year: number) => year;
  const categoryKey = (category: { id: string }) => category.id;

  const hasFilters = computed(() => selectedYears.value.length > 0 || selectedCategories.value.length > 0);

  function handleToggle(type: 'year' | 'category') {
    if (type === 'year') {
      yearDropdownOpen.value = !yearDropdownOpen.value;
      categoryDropdownOpen.value = false; 
    } else if (type === 'category') {
      categoryDropdownOpen.value = !categoryDropdownOpen.value;
      yearDropdownOpen.value = false;
    }
  }

  function handleClickOutside(event) {
    const filterArea = document.querySelector('.dropdown-area');
    if (filterArea && !filterArea.contains(event.target)) {
      yearDropdownOpen.value = false;
      categoryDropdownOpen.value = false;
    }
  }

  onMounted(() => {
    document.addEventListener('click', handleClickOutside);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
  });

  onMounted(async () => {
    await fetchFilters();
    applyFiltersFromUrl();
  });

  async function fetchFilters() {
    try {
      const response = await fetch(`${newsRestEndpoint()}/filters/${lang}`);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      years.value = data.years;
      categories.value = data.categories;
    } catch (error) {
      console.error('Error fetching filters:', error);
    }
  }

  function applyFilter() {
    emit('filter-applied', {
      years: selectedYears.value,
      categories: selectedCategories.value,
    });
  }

  function removeFilter(type: 'years' | 'categories', value: number | string) {
    if (type === 'years') {
      selectedYears.value = selectedYears.value.filter((year) => year !== value);
    } else if (type === 'categories') {
      selectedCategories.value = selectedCategories.value.filter((category) => category !== value);
    }
    applyFilter();
  }

  function removeAllFilters() {
    selectedYears.value = [];
    selectedCategories.value = [];
    applyFilter();
  }

  function getCategoryTitleById(categoryId: string): string {
    const category = categories.value.find((cat) => cat.id === categoryId);
    return category ? category.title : '';
  }

  function applyFiltersFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const year = urlParams.getAll('year');
    const categoryTitles = urlParams.getAll('category');

    if (year.length > 0) {
      selectedYears.value = years.value.filter((y) => year.includes(String(y)));
    }

    if (categoryTitles.length > 0) {
      selectedCategories.value = categories.value
        .filter((cat) => categoryTitles.includes(cat.title.toLowerCase()))
        .map((cat) => cat.id);
    }

    applyFilter();
  }

return (_ctx: any,_cache: any) => {
  return (!isMobileComputed.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(LzMultiSelectDropdown, {
            label: _unref(t).filters.yearLabel,
            items: years.value,
            selectedItems: selectedYears.value,
            "onUpdate:selectedItems": _cache[0] || (_cache[0] = ($event: any) => ((selectedYears).value = $event)),
            onApplyFilter: applyFilter,
            isOpen: yearDropdownOpen.value,
            onToggle: _cache[1] || (_cache[1] = ($event: any) => (handleToggle('year'))),
            itemKey: yearKey,
            class: "lz-inline-block"
          }, null, 8, ["label", "items", "selectedItems", "isOpen"]),
          _createVNode(LzMultiSelectDropdown, {
            label: _unref(t).filters.categoryLabel,
            items: categories.value,
            selectedItems: selectedCategories.value,
            "onUpdate:selectedItems": _cache[2] || (_cache[2] = ($event: any) => ((selectedCategories).value = $event)),
            onApplyFilter: applyFilter,
            isOpen: categoryDropdownOpen.value,
            onToggle: _cache[3] || (_cache[3] = ($event: any) => (handleToggle('category'))),
            itemKey: categoryKey,
            class: "lz-inline-block lz-ml-4"
          }, null, 8, ["label", "items", "selectedItems", "isOpen"]),
          (hasFilters.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "lz-flex lz-items-center lz-font-semibold lz-text-[#808b8e] lz-px-4 lz-ml-6 lz-cursor-pointer",
                onClick: removeAllFilters
              }, [
                _hoisted_3,
                _createTextVNode(" " + _toDisplayString(_unref(t).general.clearAllLabel), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(LzChip, {
            items: selectedYears.value,
            onRemoveItem: _cache[4] || (_cache[4] = ($event: any) => (removeFilter('years', $event)))
          }, null, 8, ["items"]),
          _createVNode(LzChip, {
            items: selectedCategories.value,
            getItemTitle: getCategoryTitleById,
            onRemoveItem: _cache[5] || (_cache[5] = ($event: any) => (removeFilter('categories', $event)))
          }, null, 8, ["items"])
        ])
      ], 512))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createVNode(LzModalFilter, {
          label: _unref(t).filters.filterLabel,
          yearItems: years.value,
          selectedYearItems: selectedYears.value,
          "onUpdate:selectedYearItems": _cache[6] || (_cache[6] = ($event: any) => ((selectedYears).value = $event)),
          onApplyFilter: applyFilter,
          itemYearKey: yearKey,
          categoryItems: categories.value,
          selectedCategoryItems: selectedCategories.value,
          "onUpdate:selectedCategoryItems": _cache[7] || (_cache[7] = ($event: any) => ((selectedCategories).value = $event)),
          itemCategoryKey: categoryKey,
          class: "lz-inline-block"
        }, null, 8, ["label", "yearItems", "selectedYearItems", "categoryItems", "selectedCategoryItems"])
      ]))
}
}

})